/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';

import ConfirmDialog from 'components/ConfirmDialog';
// import EventTracking from 'lib/EventTracking';

type Props = {
  onConfirm: Function,
  onRequestHide: () => void,
  totalRecipientCount: number,
  scheduled?: boolean,
};

class SendUrgentMessageConfirmDialog extends React.Component<Props> {
  componentDidMount() {
    /* TODO URGENTDATA?
    EventTracking.trackKey('announcements.composer.confirm_send.view', {
      organization_uuid: this.props.orgUuid,
    });
    */
  }

  render() {
    const { totalRecipientCount, onConfirm, onRequestHide, scheduled } = this.props;
    const titleText = scheduled
      ? `Schedule this urgent message to be sent to ${totalRecipientCount} people?`
      : `Send this urgent message to ${totalRecipientCount} people?`;
    const subText = `This message will be sent to all mobile devices. If recipients aren't reachable by mobile, they'll receive a text-to-voice landline call.`;
    return (
      <ConfirmDialog
        title={<span>{titleText}</span>}
        subtext={<span>{subText}</span>}
        onConfirm={onConfirm}
        onRequestHide={onRequestHide}
        actionButtonText={scheduled ? 'Schedule' : 'Send'}
        cancelButtonText="Cancel"
        // TODO URGENTDATA?
        // cancelEventKey="announcements.composer.confirm_send.cancel.click"
      />
    );
  }
}

const mapStateToProps = (state: Object) => {
  return {
    totalRecipientCount: state.roleBasedMessagingSearch.totalRecipientCount,
  };
};

export { SendUrgentMessageConfirmDialog };
export default connect(mapStateToProps)(SendUrgentMessageConfirmDialog);
